export const citizenshipList = [
  { value: "3", label: "American" },
  { value: "2", label: "Canadian" },
  { value: "1", label: "Filipino" },
  { value: "12", label: "Korean" },
  { value: "19", label: "Others" },
];